import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { AnalyticsActions } from './analytics.actions';
import { DataLayerService } from '../../modules/share/services/data-layer.service';
import { PixelParams, PixelService } from '../../modules/share/services/pixel.service';
import { getSessionId } from '@aaa/emember/store-session';
import { withLatestFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsEffects {
  dataLayerService = inject(DataLayerService);
  pixel = inject(PixelService);
  actions$ = inject(Actions);
  store = inject(Store);

  loadMembership$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AnalyticsActions.viewedPage),
        tap(({ eventName, input }) => this.dataLayerService.pageViewEvent(eventName, input)),
      ),
    { dispatch: false },
  );

  pageLoaded$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AnalyticsActions.pageLoaded),
        withLatestFrom(this.store.select(getSessionId)),
        tap(([{ feature, target, error }, sessionId]) => {
          const params: Partial<PixelParams> = {
            sessionId,
            feature,
            target,
            event: 'page',
            ...(error ? { result: 'ok' } : null),
            environment: environment.appEnv,
            clubId: environment.clubId,
          };

          this.pixel.events(params);
        }),
      ),
    { dispatch: false },
  );

  triggerButton$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AnalyticsActions.triggerButton),
        withLatestFrom(this.store.select(getSessionId)),
        tap(([{ feature, target }, sessionId]) => {
          const params: Partial<PixelParams> = {
            sessionId,
            feature,
            target,
            event: 'page',
            environment: environment.appEnv,
            clubId: environment.clubId,
          };

          this.pixel.events(params);
        }),
      ),
    { dispatch: false },
  );
}
